export default "__VITE_ASSET__69LUqdbe__"